type NavigationKeys = 'home' | 'diensten' | 'over' | 'events' | 'tips' | 'contact' | 'login' | 'logout' | 'premium' | 'waaromik';

export interface Navigation {
  [key: string]: string;
  overMij: string;
}

export interface Services {
  [key: string]: string;
}

interface IndividueleCoachingTranslations {
  title: string;
  subtitle: string;
  description: string;
  questionsTitle?: string;
  questionsParagraph?: string;
  about: {
    title: string;
    paragraph1: string;
    paragraph2: string;
    paragraph3: string;
  };
  cta: {
    title: string;
    description: string;
    button: string;
  };
  pricing: {
    singleSessions: {
      title: string;
      items: string[];
      price: string;
      button: string;
    };
    package: {
      title: string;
      items: string[];
      price: string;
      button: string;
    };
  };
}

interface WorkshopsPageTranslations {
  pageTitle: string;
  pageSubtitle: string;
  groupTrainingDescription: string;
  column1Title: string;
  column1Items: string[];
  column2Title: string;
  column2Items: string[];
  column3Title: string;
  column3Description: string;
  column3Items: string[];
  pricingTitle: string;
  pricingDescription: string;
  ctaTitle: string;
  ctaDescription: string;
  ctaButton: string;
}

interface LesgevenPageTranslations {
  title: string;
  subtitle: string;
  description: string;
  offerTitle: string;
  offerItems: string[];
  expertiseTitle: string;
  expertiseDescription: string;
  expertiseItems: string[];
  pricingTitle: string;
  pricingDescription: string;
  ctaTitle: string;
  ctaDescription: string;
  ctaButton: string;
}

interface OverTranslations {
  title: string;
  subtitle: string;
  aboutMe: {
    title: string;
    paragraph1: string;
    paragraph2: string;
    paragraph3: string;
    paragraph4: string;
    ctaButton: string;
  };
  mission: {
    title: string;
    description: string;
  };
  vision: {
    title: string;
    description: string;
    readMore: string;
    readLess: string;
  };
  whyMe: {
    title: string;
    coach: {
      title: string;
      intro: string;
      approachTitle: string;
      approachText: string;
      expectTitle: string;
      expectItems: { id: string; text: string }[];
      promiseTitle: string;
      promiseText: string;
    };
    host: {
      title: string;
      intro: string;
      approachTitle: string;
      approachText: string;
      expectTitle: string;
      expectItems: { id: string; text: string }[];
      promiseTitle: string;
      promiseText: string;
    };
  };
  cta: {
    title: string;
    description: string;
    button: string;
  };
}

interface Translations {
  navigation: Navigation;
  services: Services;
  individueleCoaching: IndividueleCoachingTranslations;
  home: {
    welcome: string;
    subtitle: string;
    intro: {
      label: string;
      title: string;
      paragraph1: string;
      paragraph2: string;
      features: {
        personalApproach: string;
        practicalMethods: string;
        lastingResults: string;
      };
    };
    features: {
      title: string;
      personalApproach: {
        title: string;
        description: string;
      };
      expertise: {
        title: string;
        description: string;
      };
      results: {
        title: string;
        description: string;
      };
    };
    testimonials: {
      title: string;
    };
    cta: {
      title: string;
      subtitle: string;
      button: string;
    };
    services: {
      title: string;
      subtitle: string;
      button: string;
    };
  };
  over: {
    title: string;
    subtitle: string;
    aboutMe: {
      title: string;
      paragraph1: string;
      paragraph2: string;
      paragraph3: string;
      paragraph4: string;
      ctaButton: string;
    };
    mission: {
      title: string;
      description: string;
    };
    vision: {
      title: string;
      description: string;
      readMore: string;
      readLess: string;
    };
    whyMe: {
      title: string;
      coach: {
        title: string;
        intro: string;
        approachTitle: string;
        approachText: string;
        expectTitle: string;
        expectItems: { id: string; text: string }[];
        promiseTitle: string;
        promiseText: string;
      };
      host: {
        title: string;
        intro: string;
        approachTitle: string;
        approachText: string;
        expectTitle: string;
        expectItems: { id: string; text: string }[];
        promiseTitle: string;
        promiseText: string;
      };
    };
    whyHost: {
      title: string;
      intro: string;
      approachTitle: string;
      approachText: string;
      expectTitle: string;
      expectItems: { id: string; text: string }[];
      promiseTitle: string;
      promiseText: string;
      ctaTitle: string;
      ctaButton: string;
    };
    cta: {
      title: string;
      description: string;
      button: string;
    };
    pageTitle: string;
    pageSubtitle: string;
    introTitle: string;
    introSubtitle: string;
    introText: string;
    missionTitle: string;
    missionText: string;
    visionText: string;
  };
  diensten: {
    title: string;
    subtitle: string;
    introTitle: string;
    introParagraph1: string;
    introParagraph2: string;
    approachTitle: string;
    approachItems: {
      icon: string;
      title: string;
      description: string;
    }[];
    expertiseLabel: string;
    servicesTitle: string;
    servicesDescription: string;
    moreInfoButton: string;
    cta: {
      title: string;
      description: string;
      contactButton: string;
      scheduleButton: string;
    };
  };
  contact: {
    title: string;
    subtitle: string;
    contactInfo: {
      title: string;
      email: string;
      availability: {
        title: string;
        days: string;
        hours: string;
      };
      company: {
        title: string;
      };
    };
    form: {
      title: string;
      name: string;
      email: string;
      phone: string;
      subject: string;
      message: string;
      service: string;
      submit: string;
      successMessage: string;
      errorMessage: string;
    };
  };
  tips: {
    title: string;
    subtitle: string;
    exclusiveContent: string;
    premiumTips: string;
    premiumDescription: string;
    premiumContent: string;
    requestAccess: string;
    premiumTitle: string;
    premiumBenefit1: string;
    premiumBenefit2: string;
    premiumBenefit3: string;
    discoverPackages: string;
    premiumCta: {
      title: string;
      description: string;
      unlockPremium: string;
      activateToday: string;
      login: string;
      noAccount: string;
      benefits: {
        exercises: string;
        templates: string;
        instructions: string;
      };
    };
    aria: {
      showMore: string;
    };
  };
  workshopsPage: WorkshopsPageTranslations;
  lesgevenPage: LesgevenPageTranslations;
  common: {
    kvk: string;
    btw: string;
    other: string;
    priceOnRequest: string;
  };
  myContent: {
    pageTitle: string;
    loading: string;
    noAccessTitle: string;
    noAccessMessage: string;
    premiumOptionsLink: string;
    noModulesTitle: string;
    noModulesMessage: string;
    moduleMaterialsTitle: string;
    moduleVideoTitle: string;
    downloadButton: string;
  };
  tierLabels: {
    self: string;
    premium: string;
    complete: string;
  };
}

export const translations: Record<'nl' | 'en', Translations> = {
  nl: {
    navigation: {
      home: 'Home',
      diensten: 'Diensten',
      over: 'Over',
      overMij: 'Over Mij',
      waaromik: 'Waarom ik',
      events: 'Events',
      tips: 'Tips',
      contact: 'Contact',
      login: 'Inloggen',
      logout: 'Uitloggen',
      premium: 'Premium'
    },
    services: {
      individueleCoaching: 'Loopbaancoaching',
      workshops: 'Solliciatietrainingen & Workshops',
      lesgeven: 'Lesgeven & Public Speaking',
      zelfcoaching: 'Zelfcoaching'
    },
    individueleCoaching: {
      title: 'Loopbaancoaching',
      subtitle: 'Professionele loopbaancoaching voor jouw carrièreontwikkeling en carrièreplanning.',
      description: 'In loopbaancoaching sessies werken we samen aan jouw persoonlijke en professionele ontwikkeling en carrièreplanning. Door middel van gerichte vragen, reflectie en bewezen methoden help ik je inzichten te krijgen in je eigen gedrag, gedachten en gevoelens. Samen ontdekken we nieuwe mogelijkheden, werken we aan concrete doelen die bijdragen aan jouw groei en meer werkgeluk.',
      questionsTitle: 'Antwoord op jouw loopbaanvragen',
      questionsParagraph: 'Tijdens loopbaancoaching help ik je antwoord te vinden op vragen zoals: "Hoe verander ik van carrière?", "Welke carrière past bij mij?", "Hoe schrijf ik een goede motivatiebrief?", "Hoe bereid ik me voor op een sollicitatiegesprek?", "Hoe maak ik een professioneel CV?", "Welke vragen worden gesteld tijdens sollicitatiegesprek?", "Hoe onderhandel ik over salaris?", en "Wat zijn de beste vacaturesites?". Samen zorgen we voor duidelijkheid en richting in jouw loopbaan.',
      about: {
        title: 'Waarom zou je voor mij kiezen als jouw loopbaancoach?',
        paragraph1: 'Zoek je niet gewoon een (nieuwe) baan, maar een carrière waar je elke dag vol plezier naartoe gaat? Waar je talenten tot bloei komen en waar je écht impact maakt? Als jouw loopbaancoach en expert in loopbaanontwikkeling help ik jou te ontdekken waar jij gelukkig van wordt en geef jou de loopbaanbegeleiding waarmee je dit kan bereiken.',
        paragraph2: 'Waar andere coaches blijven steken in algemene adviezen, duik ik graag dieper. Door mijn vermogen om snel vertrouwen op te bouwen en een persoonlijke band met mijn cliënten te creëren komen we snel tot de kern van wat jij werkelijk zoekt in je loopbaan en beroepskeuze. Ik ben oprecht geïnteresseerd in jouw succes en breng een positieve, motiverende aanpak naar onze online coaching sessies. Hierin focus ik op jouw sterke punten en zorg altijd voor een veilige, ondersteunende sfeer waarin je open en eerlijk kunt zijn. Ik ben de loopbaancoach die onvoorwaardelijk gelooft in jouw potentieel, zelfs wanneer jij dat even niet doet.',
        paragraph3: 'Of je nu een student bent die aan de start staat van je professionele loopbaan of een young professional die klaar is voor de volgende stap – mijn loopbaancoaching is volledig afgestemd op jouw situatie. Samen ontdekken we welke carrière het beste bij jou past. Ik bied je de begeleiding en ondersteuning die je nodig hebt om je ware potentieel te ontdekken en geef je het vertrouwen dat je nodig hebt om succes te behalen.'
      },
      cta: {
        title: 'Mijn belofte aan jou',
        description: 'Ben je klaar om de volgende stap in jouw loopbaan en persoonlijke effectiviteit te zetten? Plan vandaag nog jouw eerste gesprek! Plan nu je een afspraak en ontdek hoe mijn 1-1 loopbaancoaching jou kan helpen jouw doelen te bereiken!',
        button: 'Plan een afspraak'
      },
      pricing: {
        singleSessions: {
          title: 'Tarief losse coachingsessies',
          items: [
            'Coachsessies van 1 uur (ook online coaching mogelijk)',
            'Voorbereiding en follow-up van de coachsessies door de loopbaancoach',
            'Toegang tot Essential Zelfcoaching Pakket (t.w.v. €29)',
            'Hand-outs en maatwerk huiswerkopdrachten',
            '(Beperkt) tussentijds contact per mail'
          ],
          price: '€80 per uur',
          button: 'Maak een afspraak'
        },
        package: {
          title: 'Platinum',
          items: [
            'Alles uit Elite zelfcoaching voor talentontwikkeling',
            '10 persoonlijke coachingsessies (1 uur)',
            'Persoonlijk ontwikkelingsplan op maat',
            'Directe toegang tot alle premium content',
            'WhatsApp ondersteuning tussen sessies'
          ],
          price: '€990',
          button: 'Start Platinum'
        }
      }
    },
    home: {
      welcome: 'Welkom bij Sterk aan het Werk',
      subtitle: 'Ontdek wat ik voor jou kan betekenen in loopbaanadvies en training',
      intro: {
        label: 'Welkom',
        title: 'Ontdek jouw unieke loopbaanpad naar werkgeluk',
        paragraph1: 'Als professionele loopbaancoach help ik je om koers te bepalen in je carrière en carrièreplanning. Ik begeleid je bij het ontdekken van je talenten, het verkennen van mogelijkheden en het maken van bewuste keuzes die passen bij wie jij bent.',
        paragraph2: 'Of je nu vastloopt in je huidige functie, carrièreswitch advies overweegt, of simpelweg het maximale uit je professionele leven wilt halen - samen creëren we een helder beeld van jouw ideale loopbaan en de concrete stappen om daar te komen via een persoonlijk ontwikkelingsplan.',
        features: {
          personalApproach: 'Persoonlijke aanpak',
          practicalMethods: 'Praktische methodes',
          lastingResults: 'Blijvende resultaten'
        }
      },
      features: {
        title: 'Wat maakt mij uniek',
        personalApproach: {
          title: 'Persoonlijke aanpak',
          description: 'Coaching die volledig is afgestemd op jouw specifieke situatie en doelen.'
        },
        expertise: {
          title: 'Professionele expertise',
          description: 'Adviezen afgestemd op wetenschappelijk onderzoek én de praktijk.'
        },
        results: {
          title: 'Duurzame resultaten',
          description: 'Concrete tools en strategieën die je blijvend kunt toepassen in je carrière.'
        }
      },
      testimonials: {
        title: 'Wat Anderen Zeggen'
      },
      cta: {
        title: 'Klaar om je loopbaan naar een hoger niveau te tillen?',
        subtitle: 'Neem vandaag nog contact op om een kennismakingsgesprek in te plannen. Samen kijken we naar jouw specifieke situatie en wat ik voor je kan betekenen.',
        button: 'Word premium lid voor €24,99 en krijg een half jaar toegang tot alle exclusieve content!'
      },
      services: {
        title: 'Begin Vandaag Met Je Toekomst en Talentontwikkeling',
        subtitle: 'Of je nu op zoek bent naar een nieuwe uitdaging, wilt groeien in je huidige rol, of een complete carrièreswitch overweegt - ik sta klaar om je te begeleiden bij elke stap met effectieve loopbaanbegeleiding.',
        button: 'Mijn Diensten'
      }
    },
    over: {
      title: 'Over Sterk aan het Werk',
      subtitle: 'Ontdek wie ik ben en hoe ik jou kan helpen',
      aboutMe: {
        title: 'Over mij',
        paragraph1: 'Wat leuk dat je hier bent! Laat me mezelf even voorstellen. Mijn naam is Hanneke van Keulen, een gepassioneerde loopbaancoach en trainer die zich inzet om (young) professionals te helpen hun volledige potentieel te benutten en werkgeluk te vinden. Met jarenlange ervaring in loopbaanontwikkeling, carrièreplanning en training geloof ik dat ieder individu over unieke talenten en een persoonlijke visie beschikt die kunnen leiden tot transformerend succes.',
        paragraph2: 'Mijn aanpak kenmerkt zich door betrokkenheid, doelgerichtheid en persoonlijke aandacht. Ik werk nauw samen met mijn cliënten om duidelijkheid te creëren over wie zij zijn, om hun sterke punten te identificeren en uitdagingen te overwinnen. Door wetenschappelijk onderbouwde strategieën te combineren met intuïtieve inzichten, help ik je om jouw acties af te stemmen op je innerlijke waarden. Daarnaast kan ik je helpen om je ambities duidelijk op papier te zetten en deze vervolgens op een overtuigende manier te presenteren naar potentiële werkgevers. Door deze holistische methode versterk je niet alleen je professionele prestaties, maar ook je algehele welzijn.',
        paragraph3: 'Ik zorg ervoor dat elk coaching gesprek en elke sollicitatietraining zowel inspirerend als praktisch is. Of je nu een carrièreswitch advies zoekt, je kwaliteiten wilt aanscherpen of simpelweg nieuwe kansen wilt verkennen, ik begeleid je stap voor stap. Ik geloof in de kracht van gezamenlijke groei en zet me graag in om je te ondersteunen. Van het visualiseren van je droomcarrière tot het implementeren van uitvoerbare plannen die leiden tot succes: bij mij ben je aan het goede adres.',
        paragraph4: 'Wanneer ik niet aan het coachen ben, investeer ik voortdurend in mijn eigen professionele ontwikkeling door op de hoogte te blijven van de nieuwste trends en onderzoeken op het gebied van coaching en persoonlijke groei. Ik kijk ernaar uit om je te helpen je sterke punten te omarmen, uitdagingen aan te gaan en jouw carrièretraject te transformeren tot een pad van blijvende impact en oprechte voldoening. Laten we samen jouw volgende stap zetten!',
        ctaButton: 'Plan een kennismakingsgesprek'
      },
      mission: {
        title: 'Mijn Missie',
        description: '(Young) professionals te helpen bij het creëren van een succesvolle én vervullende carrière, welke in lijn is met hun authentieke zelf. Ik bied een veilige, inspirerende omgeving waarin ik hen help om hun talenten te ontdekken, zelfvertrouwen op te bouwen en regie te nemen over hun loopbaanontwikkeling.'
      },
      vision: {
        title: 'Mijn Visie',
        description: 'Ik geloof dat iedereen een carrière verdient waar hij of zij zich écht thuis voelt en werkgeluk ervaart. Waar je kunt groeien en elke dag met voldoening werkt vanuit je talenten, waarden en persoonlijke missie. Een loopbaan die niet alleen bij je past op papier, maar ook bij jou als authentiek persoon.\n\nAls carrièrecoach en expert in loopbaanadvies begeleid ik (young) professionals die vastlopen, twijfelen of simpelweg méér uit hun werk willen halen. Mijn aanpak is persoonlijk, diepgaand en altijd positief. Ik luister voorbij de woorden en help je ontdekken wat je écht drijft. In een veilige en vertrouwde setting, ook via online coaching, werken we samen aan helderheid, richting en zelfvertrouwen – zodat jij keuzes kunt maken die bij jou passen.\n\nGeen standaard adviezen, maar een traject op maat waarin we jouw kracht, potentieel en ambities centraal zetten. Ik ben pas tevreden als jij weer met energie en vertrouwen vooruit kan kijken.',
        readMore: 'Lees meer',
        readLess: 'Lees minder'
      },
      whyMe: {
        title: 'Waarom ik?',
        coach: {
          title: 'Waarom zou je voor mij kiezen als jouw carrière coach?',
          intro: 'Zoek je niet gewoon een (nieuwe) baan, maar een carrière waar je elke dag vol plezier naartoe gaat? Waar je talenten tot bloei komen en waar je écht impact maakt? Als jouw carrière coach help ik jou te ontdekken waar jij gelukkig van wordt en geef jou de loopbaanbegeleiding waarmee je dit kan bereiken.',
          approachTitle: 'Wat mijn aanpak uniek maakt',
          approachText: 'Waar andere coaches blijven steken in algemene adviezen, duik ik graag dieper. Door mijn vermogen om snel vertrouwen op te bouwen en een persoonlijke band met mijn cliënten te creëren komen we snel tot de kern van wat jij werkelijk zoekt in je loopbaan. Ik ben oprecht geïnteresseerd in jouw succes en breng een positieve, motiverende aanpak naar onze sessies. Hierin focus ik op jouw sterke punten en zorg altijd voor een veilige, ondersteunende sfeer waarin je open en eerlijk kunt zijn. Ik ben de loopbaancoach die onvoorwaardelijk gelooft in jouw potentieel, zelfs wanneer jij dat even niet doet.\\n\\nJouw reis, professioneel begeleid\\nOf je nu een student bent die aan de start staat van je professionele loopbaan of een young professional die klaar is voor de volgende stap – mijn loopbaancoaching is volledig afgestemd op jouw situatie. Samen ontdekken we welke carrière het beste bij jou past. Ik bied je de begeleiding en ondersteuning die je nodig hebt om je ware potentieel te ontdekken en geef je het vertrouwen dat je nodig hebt om succes te behalen.',
          expectTitle: 'Wat je kunt verwachten:',
          expectItems: [
            { id: 'listen', text: 'Een loopbaancoach die luistert voorbij jouw woorden en hoort wat je écht nodig hebt' },
            { id: 'insight', text: 'Duidelijk inzicht in je waarden, talenten en carrière doelen' },
            { id: 'plan', text: 'A personal development plan and concrete career plan to achieve your goals quickly' },
            { id: 'safe', text: 'A safe environment where you can be honest about yourself and your ambitions' },
            { id: 'growth', text: 'Guidance that achieves personal growth, effectiveness, and career development' }
          ],
          promiseTitle: 'Mijn belofte aan jou',
          promiseText: 'By working with me, you get a coach who challenges, inspires, and motivates you. I guide you step-by-step, celebrate successes with you, and help you overcome obstacles. This way, we not only ensure quick results but also build sustainably toward a career in which you continue to grow with confidence and pleasure. Let\'s work together to find the career for you.'
        },
        host: {
          title: '',
          intro: '',
          approachTitle: '',
          approachText: '',
          expectTitle: '',
          expectItems: [],
          promiseTitle: '',
          promiseText: ''
        }
      },
      whyHost: {
        title: 'WAAROM ZOU JE VOOR MIJ KIEZEN ALS WORKSHOP HOST/DOCENT?',
        intro: 'Zoek je iemand die meer doet dan alleen informatie overdragen? Een workshop host die energie brengt, deelnemers inspireert en zorgt voor tastbare resultaten? Dan ben ik de loopbaantrainer die je zoekt.',
        approachTitle: 'Wat mijn aanpak uniek maakt',
        approachText: 'Ik creëer een dynamische leeromgeving waar echte transformatie plaatsvindt. Door mijn vermogen om snel verbinding te maken met deelnemers ontstaat er een veilige ruimte waarin iedereen actief durft deel te nemen en zich optimaal kan ontwikkelen.\\n\\nOf je nu een online sollicitatietraining zoekt, een persoonlijke ontwikkeling coach of een inspiratiesessie wilt - mijn aanpak is volledig afgestemd op de doelstellingen van jouw organisatie. Samen zorgen we ervoor dat elke workshop niet alleen informatief is, maar vooral inspirerend en direct toepasbaar in de praktijk.',
        expectTitle: 'Wat je kunt verwachten:',
        expectItems: [
          { id: 'energy', text: 'Een energieke host die deelnemers vanaf minuut één activeert' },
          { id: 'focused', text: 'Gerichte sessies die naadloos aansluiten bij de behoeften van jouw organisatie' },
          { id: 'interactive', text: 'Een interactieve aanpak waarbij theorie direct wordt vertaald naar praktijk' },
          { id: 'safe', text: 'Een veilige leeromgeving waarin iedereen zich gezien en gehoord voelt' },
          { id: 'flexible', text: 'Flexibiliteit om in te spelen op wat er op dat moment nodig is' },
          { id: 'balance', text: 'Een perfecte balans tussen inhoud, interactie en plezier' },
          { id: 'attention', text: 'Oprechte aandacht voor de groei van elke deelnemer' }
        ],
        promiseTitle: 'Mijn belofte',
        promiseText: 'Door mij in te schakelen, kies je voor een workshop host of docent die verder gaat dan het overdragen van kennis. Ik zorg ervoor dat jouw deelnemers geïnspireerd, gemotiveerd en met concrete handvatten de deur uit gaan. Ze verlaten de sessie niet alleen met nieuwe inzichten, maar ook met de motivatie om deze direct toe te passen.',
        ctaTitle: 'Klaar om jouw volgende workshop naar een hoger niveau te tillen?',
        ctaButton: 'Laten we samen de impact vergroten!'
      },
      cta: {
        title: 'Klaar voor de volgende stap in je carrière?',
        description: 'Plan een gratis kennismakingsgesprek waarin we bespreken hoe ik je kan helpen om je professionele doelen te bereiken.',
        button: 'Plan een gesprek'
      },
      pageTitle: 'Over Mij',
      pageSubtitle: 'Leer mij kennen en ontdek mijn aanpak',
      introTitle: 'Hanneke van Keulen',
      introSubtitle: 'Loopbaancoach & Trainer',
      introText: 'Wat leuk dat je hier bent! Laat me mezelf even voorstellen. Mijn naam is Hanneke van Keulen, een gepassioneerde loopbaancoach en trainer die zich inzet om (young) professionals te helpen hun volledige potentieel te benutten en werkgeluk te vinden. Met jarenlange ervaring in loopbaanontwikkeling, carrièreplanning en training geloof ik dat ieder individu over unieke talenten en een persoonlijke visie beschikt die kunnen leiden tot transformerend succes.\n\nMijn aanpak kenmerkt zich door betrokkenheid, doelgerichtheid en persoonlijke aandacht. Ik werk nauw samen met mijn cliënten om duidelijkheid te creëren over wie zij zijn, om hun sterke punten te identificeren en uitdagingen te overwinnen. Door wetenschappelijk onderbouwde strategieën te combineren met intuïtieve inzichten, help ik je om jouw acties af te stemmen op je innerlijke waarden. Daarnaast kan ik je helpen om je ambities duidelijk op papier te zetten en deze vervolgens op een overtuigende manier te presenteren naar potentiële werkgevers, bijvoorbeeld met sollicitatiebrief schrijven hulp. Door deze holistische methode versterk je niet alleen je professionele prestaties, maar ook je algehele welzijn.\n\nIk zorg ervoor dat elk coaching gesprek en elke sollicitatietraining zowel inspirerend als praktisch is. Of je nu carrièreswitch advies zoekt, je kwaliteiten wilt aanscherpen of simpelweg nieuwe kansen wilt verkennen, ik begeleid je stap voor stap. Ik geloof in de kracht van gezamenlijke groei en zet me graag in om je te ondersteunen. Van het visualiseren van je droomcarrière tot het implementeren van uitvoerbare plannen die leiden tot succes: bij mij ben je aan het goede adres.\n\nWanneer ik niet aan het coachen ben, investeer ik voortdurend in mijn eigen professionele ontwikkeling door op de hoogte te blijven van de nieuwste trends en onderzoeken op het gebied van coaching en persoonlijke groei. Ik kijk ernaar uit om je te helpen je sterke punten te omarmen, uitdagingen aan te gaan en jouw carrièretraject te transformeren tot een pad van blijvende impact en oprechte voldoening. Laten we samen jouw volgende stap zetten!',
      missionTitle: 'Mijn Missie & Visie',
      missionText: '',
      visionText: ''
    },
    diensten: {
      title: 'Loopbaancoaching',
      subtitle: 'Ontdek hoe ik je kan helpen bij het bereiken van je carrièredoelen',
      introTitle: "Jouw Groei, Mijn Expertise",
      introParagraph1: "Elk carrièrepad is uniek. Daarom bied ik geen standaardoplossingen, maar carrière advies en maatwerk begeleiding, inclusief online loopbaancoaching, die volledig is afgestemd op jouw persoonlijke situatie, ambities en uitdagingen. Samen zetten we de koers uit naar duurzaam professioneel succes en werkgeluk.",
      introParagraph2: "Of je nu aan het begin van je loopbaan staat, carrièreswitch advies nodig hebt, je leiderschapskwaliteiten wilt versterken of effectiever wilt solliciteren, ik bied de tools, inzichten en online loopbaancoaching die je nodig hebt.",
      approachTitle: "Mijn Aanpak",
      approachItems: [
        {
          icon: 'PersonPin',
          title: 'Persoonlijk & Op Maat',
          description: 'Jouw doelen en situatie staan centraal. Geen one-size-fits-all, maar een traject specifiek voor jou ontworpen.'
        },
        {
          icon: 'VerifiedUser',
          title: 'Deskundig & Resultaatgericht',
          description: 'Gebaseerd op bewezen methoden en praktische ervaring, gericht op concrete en meetbare resultaten.'
        },
        {
          icon: 'SupportAgent',
          title: 'Ondersteunend & Vertrouwelijk',
          description: 'A safe environment where you can openly reflect, face challenges, and grow.'
        }
      ],
      expertiseLabel: 'Expertise en maatwerk',
      servicesTitle: 'Ontdek mijn diensten',
      servicesDescription: 'Hieronder vind je een overzicht van hoe ik je specifiek kan ondersteunen:',
      moreInfoButton: 'Meer informatie',
      cta: {
        title: 'Klaar om de Volgende Stap te Zetten?',
        description: 'Laat mij je helpen bij het vinden van je droombaan en het ontwikkelen van je carrière.',
        contactButton: 'Neem contact op',
        scheduleButton: 'Plan een Gesprek'
      }
    },
    contact: {
      title: 'Contact',
      subtitle: '',
      contactInfo: {
        title: 'Mijn Contactgegevens',
        email: 'Email',
        availability: {
          title: 'Beschikbaarheid',
          days: 'Maandag - Vrijdag',
          hours: '14:00 - 21:00 uur'
        },
        company: {
          title: 'Bedrijfsgegevens'
        }
      },
      form: {
        title: 'Stuur mij een bericht',
        name: 'Naam',
        email: 'Email',
        phone: 'Telefoon',
        subject: 'Onderwerp',
        message: 'Bericht',
        service: 'Dienst',
        submit: 'Versturen',
        successMessage: 'Je bericht is succesvol verzonden. Ik neem zo snel mogelijk contact met je op.',
        errorMessage: 'Er is iets misgegaan. Probeer het later opnieuw of neem direct contact op via email.'
      }
    },
    tips: {
      title: 'Carrièretips',
      subtitle: 'Vind hier gratis tips die je helpen in je loopbaanontwikkeling.',
      exclusiveContent: 'Exclusieve Content',
      premiumTips: 'Premium Carrièretips & Loopbaanontwikkeling',
      premiumDescription: 'Benieuwd naar nog meer diepgaande tips, uitgebreide gidsen en praktische tools voor je loopbaanontwikkeling en effectiever solliciteren? Word premium lid en krijg toegang tot exclusieve content die jouw carrière naar een hoger niveau tillen. Een kleine selectie van wat je kunt verwachten:',
      premiumContent: 'Premium content inclusief hulp bij het opstellen van een professioneel cv en LinkedIn profiel optimalisatie',
      requestAccess: 'Premium Aanvragen',
      premiumTitle: 'Toegang tot Premium Content',
      premiumBenefit1: 'Uitgebreide zelfreflectie oefeningen & mogelijkheid voor een beroepskeuzetest',
      premiumBenefit2: 'Downloadbare templates voor effectieve sollicitaties (incl. cv opstellen hulp & motivatiebrief voorbeeld)',
      premiumBenefit3: 'Stap-voor-stap instructies voor sollicitatiegesprek voorbereiding, ook voor digitale sollicitatiegesprekken',
      discoverPackages: 'Ontdek Premium Pakketten (incl. Voorbeelden en sjablonen voor cv\'s en motivatiebrieven)',
      premiumCta: {
        title: 'Toegang tot Premium Content',
        description: 'Activate your premium account for access to extensive self-coaching materials, exclusive tools, instructions and downloadable exercises. Discover how you can take major steps in your professional development without assistance.',
        unlockPremium: 'Unlock Premium',
        activateToday: 'Activate your premium account today and get immediate access to all exclusive content.',
        login: 'Login',
        noAccount: 'No account yet? Register on the same page.',
        benefits: {
          exercises: 'Extensive self-reflection exercises',
          templates: 'Downloadable templates for effective job applications (professioneel cv maken)',
          instructions: 'Stap-voor-stap instructies voor effectieve sollicitatietraining voor succesvolle gesprekken en salarisonderhandeling'
        }
      },
      aria: {
        showMore: 'toon meer'
      }
    },
    workshopsPage: {
      pageTitle: "Solliciatietrainingen & Workshops",
      pageSubtitle: "Inspirerende bijeenkomsten en interactieve sessies voor persoonlike en professionele groei.",
      groupTrainingDescription: "Mijn sollicitatietrainingen en workshops combineren theoretische kennis met praktische oefeningen in een dynamische setting. Deelnemers leren niet alleen van mij, maar ook van elkaars ervaringen en inzichten, wat zorgt voor een rijke leeromgeving. Door de interactieve aanpak en de uitwisseling van ervaringen ontstaan er waardevolle inzichten die direct toepasbaar zijn in de praktijk.",
      column1Title: "Persoonlijke Ontwikkeling & Loopbaanontwikkeling",
      column1Items: [
        "Effectief communiceren",
        "Verhogen van je productiviteit & persoonlijke effectiviteit",
        "Mindfulness",
        "Zelfkennis",
        "Verhogen van je zelfvertrouwen",
        "Je passie in het leven vinden"
      ],
      column2Title: "Professionele Ontwikkeling & Sollicitatievaardigheden",
      column2Items: [
        "CV of life & personal branding",
        "LinkedIn profiel optimalisatie & netwerken",
        "Sollicitatiegesprek voorbereiding (incl. digitale sollicitatiegesprekken)",
        "Professioneel CV maken",
        "Sollicitatiebrief schrijven",
        "Jezelf presenteren aan anderen",
        "Kracht vinden",
        "Work-life balans"
      ],
      column3Title: "Training op Maat (incl. Sollicitatietraining)",
      column3Description: "Maatwerk workshops en sollicitatietrainingen ontworpen om specifieke behoeften van jouw team of organisatie aan te pakken. Onderwerpen kunnen variëren van teambuilding tot leiderschapsontwikkeling en effectieve sollicitatietraining voor succesvolle gesprekken.",
      column3Items: [
        "Inhoud volledig afgestemd op jullie doelen.",
        "Interactieve en praktijkgerichte sessies.",
        "Focus op directe toepasbaarheid in de werkomgeving.",
        "Flexibele planning en locatie.",
        "Specifiek afgestemd op jouw team",
        "Onderwerpen in overleg",
        "Aansluitend bij jullie leerdoelen"
      ],
      pricingTitle: "Tarief Sollicitatietraining & Workshop",
      pricingDescription: "Prijs op aanvraag, afhankelijk van groepsgrootte en specifieke wensen.",
      ctaTitle: "Interesse in een Sollicitatietraining of Workshop?",
      ctaDescription: "Neem contact op voor meer informatie over beschikbare sessies, carrière advies, of voor een op maat gemaakt programma voor jouw team of organisatie.",
      ctaButton: "Neem contact op"
    },
    lesgevenPage: {
      title: "Lesgeven & Public Speaking",
      subtitle: "Professionele kennisoverdracht en inspirerende presentaties voor diverse doelgroepen.",
      description: "Met jarenlange ervaring in het onderwijs en als spreker bied ik boeiende lezingen en colleges die theorie en praktijk verbinden. Als universitair opgeleide spreker en trainer ben ik gespecialiseerd in het verzorgen van academisch onderwijs en trainingen gericht op loopbaanontwikkeling. Mijn ervaring omvat het geven van vakken en trainingen aan onder andere Wageningen University & Research en de Universiteit Utrecht. Mijn aanpak combineert academische diepgang met praktische toepasbaarheid, waardoor studenten en professionals direct kunnen profiteren van de opgedane kennis.",
      offerTitle: "Wat ik bied:",
      offerItems: [
        "Hoger onderwijs",
        "Online onderwijs & webinars",
        "Professionele trainingen (o.a. sollicitatietraining, persoonlijke effectiviteit)",
        "Gastcolleges",
        "Mentorschap",
        "Keynote speeches",
        "Workshop begeleiding",
        "Corporate training"
      ],
      expertiseTitle: "Academic Expertise",
      expertiseDescription: "As a university-educated speaker and trainer, I have extensive experience working with students and in academic environments. Mijn expertise omvat het ontwikkelen en verzorgen van:",
      expertiseItems: [
        "University courses and subjects",
        "Academic skills training",
        "Guest lectures and workshops (e.g., regarding job interview preparation)"
      ],
      pricingTitle: "Rate",
      pricingDescription: "Available upon request",
      ctaTitle: "Interested in a lecture or class?",
      ctaDescription: "Contact us for more information about available lectures and classes, or for a customized program for your organization or educational institution.",
      ctaButton: "Schedule a conversation"
    },
    common: {
      kvk: 'KVK: 90066200',
      btw: 'BTW: NL004785209B28',
      other: 'Geregistreerd bij',
      priceOnRequest: 'Prijs op aanvraag'
    },
    myContent: {
      pageTitle: "Mijn Leeromgeving",
      loading: "Leeromgeving laden",
      noAccessTitle: "Geen Toegang",
      noAccessMessage: "U heeft momenteel geen abonnement dat toegang geeft tot leerinhoud. Bekijk onze ",
      premiumOptionsLink: "Premium Opties",
      noModulesTitle: "Geen Modules Beschikbaar",
      noModulesMessage: "Er zijn momenteel geen modules beschikbaar voor jouw abonnementsniveau ({userTier}). Kom binnenkort terug!", 
      moduleMaterialsTitle: "Module Materialen",
      moduleVideoTitle: "Module Video",
      downloadButton: "Download"
    },
    tierLabels: {
       self: "Self Modules", 
       premium: "Premium Modules", 
       complete: "Complete Modules"
    }
  },
  en: {
    navigation: {
      home: 'Home',
      diensten: 'Services',
      over: 'About',
      overMij: 'About Me',
      waaromik: 'Why Me',
      events: 'Events',
      tips: 'Tips',
      contact: 'Contact',
      login: 'Login',
      logout: 'Logout',
      premium: 'Premium'
    },
    services: {
      individueleCoaching: 'Career Coaching',
      workshops: 'Application Trainings & Workshops',
      lesgeven: 'Teaching & Public Speaking',
      zelfcoaching: 'Self Coaching'
    },
    individueleCoaching: {
      title: 'Career Coaching',
      subtitle: 'Professional career coaching for your career development and planning.',
      description: 'In career coaching sessions, we work together on your personal and professional development and career planning. Through targeted questions, reflection, and proven methods, I help you gain insights into your own behavior, thoughts, and feelings. Together we discover new possibilities and work towards concrete goals that contribute to your growth and job satisfaction.',
      questionsTitle: 'Common Questions',
      questionsParagraph: 'Are you facing career-related questions? I can help you with:',
      about: {
        title: 'About Career Coaching',
        paragraph1: 'Career coaching is a personalized process where we work together to identify and achieve your professional goals. Whether you\'re looking for a career change, want to develop in your current role, or need guidance in making important career decisions, I\'m here to support you.',
        paragraph2: 'Through structured conversations and proven coaching methods, we explore your talents, values, and ambitions. We identify obstacles and develop strategies to overcome them. The goal is to help you make well-considered choices that align with who you are and what you want to achieve.',
        paragraph3: 'Each coaching trajectory is tailored to your specific situation and needs. We work at your pace and focus on the areas where you want to grow.'
      },
      cta: {
        title: 'Ready to Take the Next Step?',
        description: 'Let me help you discover and achieve your career goals.',
        button: 'Schedule a Free Introduction'
      },
      pricing: {
        singleSessions: {
          title: 'Single Sessions',
          items: [
            'One-on-one coaching session (60 minutes)',
            'Personal action points and exercises',
            'Follow-up by email',
            'Flexible scheduling'
          ],
          price: '€95 per session',
          button: 'Schedule a Session'
        },
        package: {
          title: 'Coaching Package (4 sessions)',
          items: [
            '4 one-on-one coaching sessions (60 minutes each)',
            'Personalized development plan',
            'Exercises and assignments between sessions',
            'Email support throughout the trajectory',
            'Final evaluation and action plan',
            'Flexible scheduling of sessions'
          ],
          price: '€345 (save €35)',
          button: 'Start Your Journey'
        }
      }
    },
    home: {
      welcome: 'Welcome to Sterk aan het Werk',
      subtitle: 'Discover what I can do for you in career advice and training',
      intro: {
        label: 'Welcome',
        title: 'Discover your unique career path to job satisfaction',
        paragraph1: 'As a professional career coach, I help you navigate your career and career planning. I guide you in discovering your talents, exploring possibilities, and making conscious choices that align with who you are.',
        paragraph2: 'Whether you\'re stuck in your current position, considering career switch advice, or simply want to get the most out of your professional life - together we create a clear vision of your ideal career and the concrete steps to get there with a personal development plan.',
        features: {
          personalApproach: 'Personal approach',
          practicalMethods: 'Practical methods',
          lastingResults: 'Lasting results'
        }
      },
      features: {
        title: 'What makes me unique',
        personalApproach: {
          title: 'Personal approach',
          description: 'Coaching that is completely tailored to your specific situation and goals.'
        },
        expertise: {
          title: 'Professional expertise',
          description: 'Advice based on scientific research and practical experience.'
        },
        results: {
          title: 'Sustainable results',
          description: 'Concrete tools and strategies that you can apply permanently in your career.'
        }
      },
      testimonials: {
        title: 'What Others Say'
      },
      cta: {
        title: 'Ready to take your career to the next level?',
        subtitle: 'Contact me today to schedule an introductory meeting. Together we will look at your specific situation and how I can help you.',
        button: 'Contact me'
      },
      services: {
        title: 'Start With Your Future and Talent Development Today',
        subtitle: 'Whether you\'re looking for a new challenge, want to grow in your current role, or are considering a complete career switch - we are ready to guide you every step of the way with effective career guidance.',
        button: 'My Services'
      }
    },
    over: {
      title: 'About Sterk aan het Werk',
      subtitle: 'Discover who I am and how I can help you',
      aboutMe: {
        title: 'About Me',
        paragraph1: 'Great to have you here! Let me introduce myself. My name is Hanneke van Keulen, a passionate career coach and trainer dedicated to helping (young) professionals reach their full potential and find job satisfaction. With years of experience in career development, career planning and training, I believe every individual has unique talents and a personal vision that can lead to transformative success.',
        paragraph2: 'Mijn aanpak kenmerkt zich door betrokkenheid, doelgerichtheid en persoonlijke aandacht. Ik werk nauw samen met mijn cliënten om duidelijkheid te creëren over wie zij zijn, om hun sterke punten te identificeren en uitdagingen te overwinnen. Door wetenschappelijk onderbouwde strategieën te combineren met intuïtieve inzichten, help ik je om jouw acties af te stemmen op je innerlijke waarden. Daarnaast kan ik je helpen om je ambities duidelijk op papier te zetten en deze vervolgens op een overtuigende manier te presenteren naar potentiële werkgevers. Door deze holistische methode versterk je niet alleen je professionele prestaties, maar ook je algehele welzijn.',
        paragraph3: 'Ik zorg ervoor dat elk coaching gesprek en elke sollicitatietraining zowel inspirerend als praktisch is. Of je nu een carrièreswitch advies zoekt, je kwaliteiten wilt aanscherpen of simpelweg nieuwe kansen wilt verkennen, ik begeleid je stap voor stap. Ik geloof in de kracht van gezamenlijke groei en zet me graag in om je te ondersteunen. Van het visualiseren van je droomcarrière tot het implementeren van uitvoerbare plannen die leiden tot succes: bij mij ben je aan het goede adres.',
        paragraph4: 'Wanneer ik niet aan het coachen ben, investeer ik voortdurend in mijn eigen professionele ontwikkeling door op de hoogte te blijven van de nieuwste trends en onderzoeken op het gebied van coaching en persoonlijke groei. Ik kijk ernaar uit om je te helpen je sterke punten te omarmen, uitdagingen aan te gaan en jouw carrièretraject te transformeren tot een pad van blijvende impact en oprechte voldoening. Laten we samen jouw volgende stap zetten!',
        ctaButton: 'Plan a consultation'
      },
      mission: {
        title: 'My Mission',
        description: 'To help (young) professionals create a successful and fulfilling career that aligns with their authentic selves. I offer a safe, inspiring environment where I help them discover their talents, build self-confidence, and take control of their career development.'
      },
      vision: {
        title: 'My Vision',
        description: 'I believe everyone deserves a career where they truly feel at home and experience job satisfaction. Where you can grow and work with fulfillment every day, leveraging your talents, values, and personal mission. A career that not only fits you on paper but also aligns with who you are as an authentic person.\n\nAs a career coach and expert in career advice, I guide (young) professionals who feel stuck, are in doubt, or simply want to get more out of their work. My approach is personal, in-depth, and always positive. I listen beyond the words and help you discover what truly drives you. In a safe and trusted setting, including through online coaching, we work together on clarity, direction, and self-confidence – so you can make choices that suit you.\n\nNo standard advice, but a tailored journey where we put your strength, potential, and ambitions at the center. I\'m only satisfied when you can look forward with energy and confidence again.',
        readMore: 'Read more',
        readLess: 'Read less'
      },
      whyMe: {
        title: 'Why Me?',
        coach: {
          title: 'Why choose me as your career coach?',
          intro: 'Are you looking for more than just a (new) job, but a career that you look forward to every day? Where your talents flourish and where you truly make an impact? As your career coach, I help you discover what makes you happy and provide the career guidance to achieve it.',
          approachTitle: 'What makes my approach unique',
          approachText: 'While other coaches stick to general advice, I like to dive deeper. Through my ability to quickly build trust and create a personal connection with my clients, we quickly get to the core of what you\'re truly looking for in your career. I am genuinely interested in your success and bring a positive, motivating energy to our sessions. I focus on your strengths and always ensure a safe, supportive atmosphere where you can be open and honest.\n\nYour journey, professionally guided\nWhether you\'re a student at the beginning of your professional career or a young professional ready for the next step – my coaching is completely tailored to your situation. Together we discover which career suits you best. I provide you with the guidance and support you need to discover your true potential and give you the confidence you need to achieve success. I am the coach who unconditionally believes in your potential.',
          expectTitle: 'What you can expect:',
          expectItems: [
            { id: 'listen', text: 'A coach who listens beyond your words and hears what you truly want and need' },
            { id: 'insight', text: 'Clear insight into your values, talents, and career goals' },
            { id: 'plan', text: 'A personal development plan and concrete career plan to achieve your goals quickly' },
            { id: 'safe', text: 'A safe environment where you can be honest about yourself and your ambitions' },
            { id: 'growth', text: 'Guidance that achieves personal growth, effectiveness, and career development' }
          ],
          promiseTitle: 'My promise to you',
          promiseText: 'By working with me, you get a coach who challenges, inspires, and motivates you. I guide you step-by-step, celebrate successes with you, and help you overcome obstacles. This way, we not only ensure quick results but also build sustainably toward a career in which you continue to grow with confidence and pleasure. Let\'s work together to find the career for you.'
        },
        host: {
          title: '',
          intro: '',
          approachTitle: '',
          approachText: '',
          expectTitle: '',
          expectItems: [],
          promiseTitle: '',
          promiseText: ''
        }
      },
      whyHost: {
        title: 'WHY CHOOSE ME AS A WORKSHOP HOST/TEACHER?',
        intro: 'Are you looking for someone who does more than just transfer information? A workshop host who brings energy, inspires participants, and ensures tangible results? Then I am the career trainer you are looking for.',
        approachTitle: 'What makes my approach unique',
        approachText: 'I create a dynamic learning environment where real transformation takes place. My ability to quickly connect with participants creates a safe space where everyone dares to actively participate and develop optimally.\n\nWhether you are looking for online job application training, a personal development coach, or an inspirational session - my approach is fully tailored to your organization\'s objectives. Together, we ensure that every workshop is not only informative but also inspiring and directly applicable in practice.',
        expectTitle: 'What you can expect:',
        expectItems: [
          { id: 'energy', text: 'A host who brings energy and activates participants from minute one' },
          { id: 'focused', text: 'Focused sessions that seamlessly align with your organization\'s needs' },
          { id: 'interactive', text: 'An interactive approach where theory is directly translated into practice' },
          { id: 'safe', text: 'A safe learning environment where everyone feels seen and heard' },
          { id: 'flexible', text: 'Flexibility to respond to what is needed in the moment' },
          { id: 'balance', text: 'Een perfecte balans tussen inhoud, interactie en plezier' },
          { id: 'attention', text: 'Genuine attention to the growth of each participant' }
        ],
        promiseTitle: 'My Promise',
        promiseText: 'By hiring me, you choose a workshop host or teacher who goes beyond transferring knowledge. I ensure that your participants leave inspired, motivated, and with concrete tools. They leave the session not only with new insights but also with the motivation to apply them immediately.',
        ctaTitle: 'Ready to take your next workshop to the next level?',
        ctaButton: 'Let\'s increase the impact together!'
      },
      cta: {
        title: 'Ready for the next step in your career?',
        description: 'Schedule a free consultation where we\'ll discuss how I can help you achieve your professional goals.',
        button: 'Schedule a consultation'
      },
      pageTitle: 'About Me',
      pageSubtitle: 'Get to know me and discover my approach',
      introTitle: 'Hanneke van Keulen',
      introSubtitle: 'Career Coach & Trainer',
      introText: 'Great to have you here! Let me introduce myself. My name is Hanneke van Keulen, a passionate career coach and trainer dedicated to helping (young) professionals reach their full potential and find job satisfaction. With years of experience in career development, career planning and training, I believe every individual has unique talents and a personal vision that can lead to transformative success.\n\nMy approach is characterized by commitment, purposefulness, and personal attention. I work closely with my clients to create clarity about who they are, identify their strengths, and overcome challenges. By combining scientifically grounded strategies with intuitive insights, I help you align your actions with your inner values. I can also help you clearly articulate your ambitions on paper and then present them convincingly to potential employers, for example, with help writing cover letters. Through this holistic method, you strengthen not only your professional performance but also your overall well-being.\n\nI ensure that each coaching conversation and each application training is both inspiring and practical. Whether you are seeking career switch advice, want to refine your qualities, or simply explore new opportunities, I guide you step by step. I believe in the power of collective growth and am committed to supporting you. From visualizing your dream career to implementing actionable plans that lead to success: you\'ve come to the right place.\n\nWhen I\'m not coaching, I continuously invest in my own professional development by staying informed about the latest trends and research in coaching and personal growth. I look forward to helping you embrace your strengths, address challenges, and transform your career journey into a path of lasting impact and genuine satisfaction. Let\'s take your next step together!',
      missionTitle: 'My Mission & Vision',
      missionText: '',
      visionText: ''
    },
    diensten: {
      title: 'Loopbaancoaching',
      subtitle: 'Discover how I can help you achieve your career goals',
      introTitle: "Your Growth, My Expertise",
      introParagraph1: "Every career path is unique. That's why I don't offer standard solutions, but career advice and tailored guidance, including online career coaching, fully aligned with your personal situation, ambitions, and challenges. Together, we set the course for sustainable professional success and job satisfaction.",
      introParagraph2: "Whether you're at the beginning of your career, need career switch advice, want to strengthen your leadership skills or want to improve your job application skills, I provide the tools, insights, and online career coaching you need.",
      approachTitle: "My Approach",
      approachItems: [
        {
          icon: 'PersonPin',
          title: 'Personal & Tailored',
          description: 'Your goals and situation are central. No one-size-fits-all, but a program specifically designed for you.'
        },
        {
          icon: 'VerifiedUser',
          title: 'Expert & Results-Oriented',
          description: 'Based on proven methods and practical experience, focused on concrete and measurable results.'
        },
        {
          icon: 'SupportAgent',
          title: 'Supportive & Confidential',
          description: 'A safe environment where you can openly reflect, face challenges, and grow.'
        }
      ],
      expertiseLabel: 'Expertise and customization',
      servicesTitle: 'Discover my services',
      servicesDescription: 'Below you will find an overview of how I can specifically support you:',
      moreInfoButton: 'More information',
      cta: {
        title: 'Klaar om de Volgende Stap te Zetten?',
        description: 'Let me help you find your dream job and develop your career.',
        contactButton: 'Contact me',
        scheduleButton: 'Schedule a Meeting'
      }
    },
    contact: {
      title: 'Contact',
      subtitle: '',
      contactInfo: {
        title: 'My Contact Details',
        email: 'Email',
        availability: {
          title: 'Availability',
          days: 'Monday - Friday',
          hours: '14:00 - 21:00'
        },
        company: {
          title: 'Company Details'
        }
      },
      form: {
        title: 'Send me a message',
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        subject: 'Subject',
        message: 'Message',
        service: 'Service',
        submit: 'Send',
        successMessage: 'Your message has been successfully sent. I will contact you as soon as possible.',
        errorMessage: 'Something went wrong. Please try again later or contact me directly via email.'
      }
    },
    tips: {
      title: 'Career Tips',
      subtitle: 'Find free tips here to help you in your career development.',
      exclusiveContent: 'Exclusive Content',
      premiumTips: 'Premium Career Tips & Career Development',
      premiumDescription: 'Curious about more in-depth tips, extensive guides, and practical tools for your career development and effective job searching? Become a premium member and get access to exclusive content that will take your career to the next level. A small selection of what you can expect:',
      premiumContent: 'Premium content including help creating a professional CV and LinkedIn profile optimization',
      requestAccess: 'Request Premium Access',
      premiumTitle: 'Access to Premium Content',
      premiumBenefit1: 'Extensive self-reflection exercises & opportunity for a career choice test',
      premiumBenefit2: 'Downloadable templates for effective job applications (incl. CV creation help & cover letter example)',
      premiumBenefit3: 'Step-by-step instructions for job interview preparation, also for digital job interviews',
      discoverPackages: 'Discover Premium Packages (incl. Examples and templates for CVs and cover letters)',
      premiumCta: {
        title: 'Access to Premium Content',
        description: 'Activate your premium account for access to extensive self-coaching materials, exclusive tools, instructions and downloadable exercises. Discover how you can take major steps in your professional development without assistance.',
        unlockPremium: 'Unlock Premium',
        activateToday: 'Activate your premium account today and get immediate access to all exclusive content.',
        login: 'Login',
        noAccount: 'No account yet? Register on the same page.',
        benefits: {
          exercises: 'Extensive self-reflection exercises',
          templates: 'Downloadable templates for effective job applications (professioneel cv maken)',
          instructions: 'Step-by-step instructions for effective application training for successful interviews and salary negotiation'
        }
      },
      aria: {
        showMore: 'show more'
      }
    },
    workshopsPage: {
      pageTitle: "Application Trainings & Workshops",
      pageSubtitle: "Inspiring gatherings and interactive sessions for personal and professional growth.",
      groupTrainingDescription: "Mijn application trainings en workshops combineren theoretische kennis met praktische oefeningen in een dynamische setting. Deelnemers leren niet alleen van mij, maar ook van elkaars ervaringen en inzichten, wat zorgt voor een rijke leeromgeving. Door de interactieve aanpak en de uitwisseling van ervaringen ontstaan er waardevolle inzichten die direct toepasbaar zijn in de praktijk.",
      column1Title: "Personal Development & Career Development",
      column1Items: [
        "Communicating effectively",
        "Increasing your productivity & personal effectiveness",
        "Mindfulness",
        "Self-knowledge",
        "Increasing your confidence",
        "Finding your passion in life"
      ],
      column2Title: "Professional Development & Application Skills",
      column2Items: [
        "CV of life & personal branding",
        "LinkedIn profile optimization & networking strategies",
        "Job interview preparation (incl. digital job interviews)",
        "Professional CV creation",
        "Writing application letters",
        "Presenting yourselves to others",
        "Strength finding",
        "Work-life balance"
      ],
      column3Title: "Custom Training (incl. Application Training)",
      column3Description: "Tailor-made workshops and application trainings designed to address the specific needs of your team or organization. Topics can range from team building to leadership development and effective application training for successful interviews.",
      column3Items: [
        "Content fully tailored to your goals.",
        "Interactive and practice-oriented sessions.",
        "Focus on direct applicability in the work environment.",
        "Flexibele planning en locatie.",
        "Specifiek afgestemd op jouw team",
        "Onderwerpen in overleg",
        "Aansluitend bij jullie leerdoelen"
      ],
      pricingTitle: "Application Training & Workshop Rate",
      pricingDescription: "Price on request, depending on group size and specifieke wensen.",
      ctaTitle: "Interesse in an Application Training or Workshop?",
      ctaDescription: "Contact us for more information about available sessions, career advice, or for a customized program for your team or organization.",
      ctaButton: "Contact us"
    },
    lesgevenPage: {
      title: "Teaching & Public Speaking",
      subtitle: "Professional knowledge transfer and inspiring presentations for diverse audiences.",
      description: "With years of experience in education and as a speaker, I offer engaging lectures and classes that connect theory and practice. As a university-educated speaker and trainer, I specialize in providing academic education and training focused on career development. My experience includes teaching courses and training at Wageningen University & Research and Utrecht University, among others. My approach combines academic depth with practical applicability, allowing students and professionals to directly benefit from the acquired knowledge.",
      offerTitle: "What I offer:",
      offerItems: [
        "Higher education",
        "Online education & webinars",
        "Professional training (incl. application training, personal effectiveness)",
        "Guest lectures",
        "Mentorship",
        "Keynote speeches",
        "Workshop facilitation",
        "Corporate training"
      ],
      expertiseTitle: "Academic Expertise",
      expertiseDescription: "As a university-educated speaker and trainer, I have extensive experience working with students and in academic environments. My expertise includes developing and delivering:",
      expertiseItems: [
        "University courses and subjects",
        "Academic skills training",
        "Guest lectures and workshops (e.g., regarding job interview preparation)"
      ],
      pricingTitle: "Rate",
      pricingDescription: "Available upon request",
      ctaTitle: "Interested in a lecture or class?",
      ctaDescription: "Contact us for more information about available lectures and classes, or for a customized program for your organization or educational institution.",
      ctaButton: "Schedule a conversation"
    },
    common: {
      kvk: 'CoC: 90066200',
      btw: 'VAT: NL004785209B28',
      other: 'Registered at',
      priceOnRequest: 'Price on request',
    },
    myContent: {
      pageTitle: "My Learning Environment",
      loading: "Loading learning environment",
      noAccessTitle: "No Access",
      noAccessMessage: "You currently do not have a subscription that grants access to learning content. View our ",
      premiumOptionsLink: "Premium Options",
      noModulesTitle: "No Modules Available",
      noModulesMessage: "There are currently no modules available for your subscription level ({userTier}). Check back soon!", 
      moduleMaterialsTitle: "Module Materials",
      moduleVideoTitle: "Module Video",
      downloadButton: "Download"
    },
    tierLabels: {
       self: "Self Modules", 
       premium: "Premium Modules", 
       complete: "Complete Modules"
    }
  }
};